export default __webpack_public_path__ + "static/media/blog.6e39cb05.jpg";